@reference "../../../theme.css";

@layer atoms.brand-mark.base {
	.brand-mark {
		@apply inline-block object-contain;
	}

	.brand-mark--sm {
		@apply h-10 w-10;
	}

	.brand-mark--md {
		@apply h-16 w-16;
	}

	.brand-mark--lg {
		@apply h-24 w-24;
	}
} /* end @layer atoms.brand-mark.base */
